export default __webpack_public_path__ + "static/media/menu-bottom1x.5b32339b.png";